import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { InferenceAPI, useTokenAndOrgId } from './utils'
import { ServerTemplateRequest } from './inference.gen'

export const useListServerTemplates = () => {
  const { orgId, token } = useTokenAndOrgId()

  return useQuery({
    queryKey: ['list-server-templates', orgId, token],
    enabled: !!orgId && !!token,
    queryFn: async () => {
      const result = await InferenceAPI.listServerTemplates({
        request: {
          page_number: 1,
          page_size: 100,
          is_public: false,
        },
      })

      return result.templates
    },
  })
}

export const useCreateServerTemplate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: {
      request: ServerTemplateRequest
      price_per_hour: number
    }) => {
      const result = await InferenceAPI.createServerTemplate({
        request: data.request,
        price_per_hour: data.price_per_hour,
      })

      queryClient.invalidateQueries({
        queryKey: ['list-server-templates'],
        exact: false,
      })

      return result.ok
    },
  })
}

export const useGetServerTemplate = (templateId: number) => {
  const { orgId, token } = useTokenAndOrgId()

  return useQuery({
    queryKey: ['server-template', templateId, orgId, token],
    enabled: !!templateId && !!orgId && !!token,
    queryFn: async () => {
      const result = await InferenceAPI.getServerTemplate({
        template_id: templateId,
      })

      return result.template
    },
  })
}

export const useDeleteServerTemplate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (templateId: number) => {
      const result = await InferenceAPI.deleteServerTemplate({
        template_id: templateId,
      })

      queryClient.invalidateQueries({
        queryKey: ['list-server-templates'],
        exact: false,
      })

      return result.ok
    },
  })
}
